const locale = {
  'commodityList.message.enterOE': 'Пожалуйста, введите номер OE',
  'commodityList.message.addSuccess': 'Добавлено в корзину, можно перейти в корзину',
  'commodityList.message.fetchProductsSuccess': 'Пакетный поиск успешно завершен',
  'commodityList.message.placeholderOENumber': `Запросите до 1000 номеров OE за раз; разделите несколько записей по строкам, например:
000001
000002
000003`,
  'commodityList.text.AllTotal': 'Для вас найдено {total} результатов',
  'commodityList.text.groupTotal': 'найдено {total} результатов',
  'commodityList.button.search': 'Поиск',
  'commodityList.button.reset': 'Сброс',
  'commodityList.title.accessoriesDetails': 'Детали аксессуаров',
  'commodityList.title.replacementNumber': 'Номер замены',
  'commodityList.title.storeName': 'Магазин',
  'commodityList.title.availabilityAndLeadTime': 'Наличие и время доставки',
  'commodityList.title.price': 'Цена',
  'commodityList.title.operation': 'Операция',
  'commodityList.message.selectProduct': 'Пожалуйста, выберите продукты для добавления',
  'commodityList.text.selectedProducts': 'Выбрано {count} продуктов ({quantity} единиц),',
  'commodityList.text.total': 'Итого:',
  'commodityList.button.batchAddToCart': 'В корзину',
  'commodityList.message.maxDataLimit':
    'Превышение 2000 элементов, будут искаться только первые 2000',
  'commodityList.message.noImportData': 'Нет данных для импорта',
  'commodityList.message.batchQueryLoading': 'Пакетный поиск...',
  'commodityList.message.noProductData': 'Нет данных о товарах',
  'commodityList.message.settleSuccess': 'Счет успешно сохранен',
  'commodityList.message.orderFailed': 'Не удалось оформить заказ, попробуйте позже',
  'commodityList.button.orderNow': 'Оформить заказ',
  'commodityList.import.oeNumber': 'Номер детали', // 零件号
  'commodityList.import.brand': 'Бренд аксессуаров', // 配件品牌
  'commodityList.import.quantity': 'Количество',
  'commodityList.import.rule1': '1. Поддерживаются только файлы .xlsx.',
  'commodityList.import.rule2':
    '2. После загрузки можно массово добавлять или обновлять список. В таблице ниже показаны импортируемые поля, * означает обязательное.',
  'commodityList.button.batchImport': 'Массовый импорт',
  'commodityList.text.supportBatchQuery':
    'Поддерживается массовый поиск OE номеров и автозаполнение количества',

  'commodityList.import.downloadTemplateUrl':
    'https://fe-static.cassmall.com/assets/applications/20250715163719/Импорт шаблонов.xlsx',

  'commodityList.message.invalidData':
    'Некоторые количества товаров не соответствуют требованиям, пожалуйста, проверьте',

  'commodity.multiple-sale.error.minSaleCount':
    'Количество покупки не может быть меньше минимального количества продаж',
  'commodity.multiple-sale.error.multipleSaleCount':
    'Количество покупки должно быть кратно количеству множественных продаж',
  total_match_found: '{total} результатов найдено',
  total_Item_selected: '{total} товаров выбрано',
  Total_colon_total: 'Итого: {total}',
  Request_a_quote: 'Запросить предложение',
  Coming_soon: 'Скоро',
  Place_order: 'Оформить заказ',
  Specifications: 'Спецификации',
  Pack_Size: 'Размер упаковки',
  total_pcs_case: '{total} pcs/case',
  MOQ: 'MOQ',
  total_pcs: '{total} pcs',
  In_stock: 'В наличии',
  Backorder: 'Под заказ',
  Immediate: 'Срочно',
  total_Found: '{total} Найдено',
  total_Unfound: '{total} Не найдено',
  Availability_and_Lead_Time_Tip:
    'Время доставки — это период с момента размещения заказа до момента готовности товаров к отправке.',
  Supported_Manufacturers: 'Поддерживаемые производители',
};

export default locale;
